import { Component } from '@angular/core';
import { MsgTimelineContent } from '../../msg-interface/msg-timeline-content';
import { _MSGTYPES } from '../../shared/constant/msgType';
import { TimelineSourceData } from '../../msg-interface/data-model';
import { URLS } from '../../shared/constant/interface';

@Component({
  selector: 'icc-voice-timeline-content',
  template: `
    <div *ngIf="!isMo" class="left-align">{{ content }}</div>
    <icc-audio *ngIf="isMo" [url]="content"></icc-audio>
  `,
  styles: ['.left-align {text-align:left;}'],
})
export class VoiceTimelineContentComponent implements MsgTimelineContent {
  constructor() {}
  SCENE = 'icc-msg-timeline-content';
  type = _MSGTYPES.MT.VOICE.type;
  isMo: boolean;
  content: string;

  // 地址前缀
  baseUrl = URLS.attachment.url + '?';

  /* 赋值 */
  setData(data: TimelineSourceData) {
    this.isMo = data.isMo;
    this.content = this.isMo ? this.baseUrl + JSON.parse(data.content).content : data.content || '【语音内容为空】';
  }
}
